<template>
  <div class="main__section">
    <h1 class="section__title">
      Чат-боты -> <router-link to="/requests">Запросы</router-link> -> {{ this.$route.params.id }}
    </h1>
    <div class="main__body">
      <div class="form-body">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">Вопрос</th>
            <th scope="col">Ответ</th>
            <th scope="col">Дата</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in allBranchRequest">
            <th scope="row">
              {{ index + 1}}
            </th>
            <td v-html="item.questionName"></td>
            <td v-if="item.buttonName">{{ item.buttonName }}</td>
            <td v-else-if="!item.photo && !item.answerName">-</td>
            <td v-else-if="!item.photo && item.answerName"> {{ item.answerName }}</td>
            <td v-else-if="item.photo">
              <div class="images" v-viewer>
                <img class="pointer" style="width: 150px;" :src="'https://api.expansium.ru/img/attachment/image/' + item.photo">
              </div>
            </td>
            <td>{{ item.date_create }} / {{ item.date_update }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'view-request',
  computed: mapGetters(['allBranchRequest']),
  async mounted() {
    this.getRequest();
  },
  methods: {
    getRequest: function(){
      this.$store.dispatch('getRequest', this.$route.params.id);
    },
  },
}
</script>